import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  LayoutDashboard,
  ClipboardList,
  CalendarDays,
  MessageSquare,
  User,
  Briefcase,
  Wallet,
  Brain,
  FileText,
} from 'lucide-react';
import DashboardLayout from './DashboardLayout';
import WorkerStatusGate from '@/components/worker/WorkerStatusGate';
import { workerBottomNav } from '@/lib/navigation';

export default function WorkerLayout() {
  const { t } = useTranslation('worker');

  const navItems = useMemo(
    () => [
      { to: '/worker', icon: LayoutDashboard, label: t('nav.dashboard') },
      { to: '/worker/comenzi', icon: ClipboardList, label: t('nav.jobs') },
      { to: '/worker/program', icon: CalendarDays, label: t('nav.schedule') },
      { to: '/worker/castiguri', icon: Wallet, label: t('nav.earnings') },
      { to: '/worker/mesaje', icon: MessageSquare, label: t('nav.messages') },
      { to: '/worker/profil', icon: User, label: t('nav.settings') },
      { to: '/worker/test-personalitate', icon: Brain, label: t('nav.personality') },
      { to: '/worker/documente-obligatorii', icon: FileText, label: t('nav.documents') },
    ],
    [t],
  );

  return (
    <DashboardLayout
      navItems={navItems}
      bottomNavItems={workerBottomNav(t)}
      logoIcon={Briefcase}
      logoIconColor="text-accent"
      subtitle={t('nav.subtitle')}
      homeRoute="/worker"
      wrapper={(children) => <WorkerStatusGate>{children}</WorkerStatusGate>}
    />
  );
}
